'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default',
        '& $item': {
          color: theme.pagination.itemColor,
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          '&:hover': {
            cursor: 'default'
          }
        },
        '& $item.active': {
          color: theme.pagination.itemActiveColor,
          backgroundColor: theme.pagination.itemActiveBgColor,
          borderColor: theme.pagination.itemActiveBorderColor
        },
        '& $icon': {
          color: theme.pagination.iconColor,
          '&:hover': {
            color: theme.pagination.iconColor,
            cursor: 'default'
          }
        }
      },
      '&.hidden': {
        display: 'none'
      }
    },
    label: {
      flex: '1 1 auto',
      fontSize: theme.pagination.fontSize,
      lineHeight: '19px',
      padding: '2px 0 3px 0',
      '& .range': {
        fontWeight: theme.pagination.fontWeightSemibold
      }
    },
    pagination: {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'center',
      '&.hidden': {
        display: 'none'
      }
    },
    iconContainer: {
      flex: '0 0 auto',
      width: 24,
      height: 24
    },
    iconNext: {
      marginLeft: 2,
      '& $icon': {
        transform: 'rotate(-90deg)'
      }
    },
    iconPrev: {
      marginRight: 2,
      '& $icon': {
        transform: 'rotate(90deg)'
      }
    },
    icon: {
      padding: 8,
      display: 'block',
      color: theme.pagination.iconColor,
      '&:hover': {
        color: theme.pagination.iconHoverColor,
        cursor: 'pointer'
      },
      '&.hidden': {
        display: 'none'
      }
    },
    list: {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center'
    },
    item: {
      flex: '0 0 auto',
      minWidth: 24,
      height: 24,
      margin: '0 2px',
      boxSizing: 'border-box',
      borderRadius: theme.pagination.itemBorderRadius,
      color: theme.pagination.itemColor,
      textAlign: 'center',
      borderColor: 'transparent',
      borderWidth: 1,
      borderStyle: 'solid',
      fontSize: theme.pagination.fontSize,
      lineHeight: '19px',
      padding: '1px 0 2px 0',
      userSelect: 'none',
      '&:hover': {
        cursor: 'pointer',
        color: theme.pagination.itemHoverColor,
        backgroundColor: theme.pagination.itemHoverBgColor,
        borderColor: theme.pagination.itemHoverBorderColor
      },
      '&.active': {
        color: theme.pagination.itemActiveColor,
        backgroundColor: theme.pagination.itemActiveBgColor,
        borderColor: theme.pagination.itemActiveBorderColor,
        '&:hover': {
          cursor: 'default'
        }
      },
      '&.disabled': {
        color: theme.pagination.itemColor,
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        '&:hover': {
          cursor: 'default'
        }
      }
    }
  };
};